/* «Express από Ευρώπη» popup, inquiry only (ORG-714). Markup + the qualifying rule:
   snippets/express-eu.liquid. A plane button on a variants-table row, or «Πώς λειτουργεί» on
   the notice line, opens one shared <dialog>; the clicked row's code goes into the heading
   and the mailto subject/body. Clicks are published as Shopify customer events
   (express_eu_open / _email / _phone); the custom pixel in Admin forwards them to GA4
   (docs/projects/theme/reference/express-eu.md). Rows added by «load more» work too: the
   open handler is delegated on the document. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-express-dialog]');
  if (!dlg) return;
  var codeLabel = dlg.querySelector('[data-express-code-label]');
  var codeText = dlg.querySelector('[data-express-code-text]');
  var email = dlg.querySelector('[data-express-email]');
  var phone = dlg.querySelector('[data-express-phone]');
  var code = '';
  var source = '';
  var lastTrigger = null;

  function track(name) {
    var data = { product_code: code, product: dlg.dataset.productName || '', source: source };
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics must never break the popup */ }
  }

  function mailto() {
    var subject = (dlg.dataset.subject || '').replace('__CODE__', code || dlg.dataset.productName || '');
    var body = (dlg.dataset.body || '').replace('__CODE__', code);
    return 'mailto:' + dlg.dataset.email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function open(trigger) {
    code = trigger.getAttribute('data-express-code') || '';
    source = trigger.closest('[data-express-notice]') ? 'notice' : 'row';
    lastTrigger = trigger;
    codeText.textContent = code;
    codeLabel.hidden = !code;
    email.href = mailto();
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
    document.documentElement.classList.add('xe-locked');
    track('express_eu_open');
  }

  function close() {
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-express-open]');
    if (!t) return;
    e.preventDefault();
    open(t);
  });
  // The inner box fills the dialog, so a click whose target is the <dialog> itself landed on
  // the backdrop.
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-express-close]')) close();
  });
  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('xe-locked');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  });
  email.addEventListener('click', function () { track('express_eu_email'); });
  phone.addEventListener('click', function () { track('express_eu_phone'); });
})();
